/**
 * Замер CAD (референс MeasureBar): клики по карте ставят точки, панель
 * показывает суммарную длину и площадь (при ≥3 точках, сферическая формула).
 */
import { haversineM } from '@app/geo'
import { tr } from '@app/i18n'
import { langTick, measureActive, measurePoints, venueMap } from '../state'

function totalMeters(points: readonly (readonly [number, number])[]): number {
  let total = 0
  for (let i = 1; i < points.length; i++) {
    const a = points[i - 1]
    const b = points[i]
    if (a && b) total += haversineM(a, b)
  }
  return total
}

/** Площадь малого сферического полигона, м² (как в референсе). */
function areaSqm(points: readonly (readonly [number, number])[]): number {
  if (points.length < 3) return 0
  const R = 6371000
  let area = 0
  for (let i = 0; i < points.length; i++) {
    const a = points[i]
    const b = points[(i + 1) % points.length]
    if (!a || !b) continue
    const lat1 = (a[1] * Math.PI) / 180
    const lat2 = (b[1] * Math.PI) / 180
    const lng1 = (a[0] * Math.PI) / 180
    const lng2 = (b[0] * Math.PI) / 180
    area += (lng2 - lng1) * (2 + Math.sin(lat1) + Math.sin(lat2))
  }
  return Math.abs((area * R * R) / 2)
}

export function MeasureBar() {
  langTick.value
  const points = measurePoints.value
  const total = Math.round(totalMeters(points))
  const area = Math.round(areaSqm(points))

  const clear = (): void => {
    measurePoints.value = []
    venueMap.value?.setMeasure(null)
  }

  const finish = (): void => {
    measureActive.value = false
    clear()
  }

  return (
    <div class="measure-bar glass anim-toast" role="status">
      <div class="measure-info">
        <p class="tech-label measure-kicker">{tr('measure.kicker')}</p>
        <p class="measure-values">
          <b>
            {total} {tr('unit.m')}
          </b>
          {area > 0 && (
            <span class="measure-area">
              ({area} {tr('unit.m2')})
            </span>
          )}
          <span class="tech-label measure-count">
            {tr('measure.points', { n: String(points.length) })}
          </span>
        </p>
      </div>
      {points.length === 0 ? (
        <p class="measure-hint">{tr('measure.hint')}</p>
      ) : (
        <div class="measure-actions">
          <button type="button" class="measure-btn measure-btn-clear" onClick={clear}>
            {tr('measure.clear')}
          </button>
          <button type="button" class="measure-btn measure-btn-done" onClick={finish}>
            {tr('measure.done')}
          </button>
        </div>
      )}
    </div>
  )
}
